import { Button, Grid, TextField, MenuItem, IconButton, DialogActions } from '@mui/material';
import React, { useState, useContext } from 'react';
import { AlertMessagesContext } from 'react-alert-messages';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import VendorServices from 'services/VendorServices';
import NumberField from 'components/library/NumberField';
import { useTranslation } from 'react-i18next';

export default function NewVendorDialog({ onSuccess, onClose }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const TYPE = {
    CREDIT: 'Credit',
    ADVANCE: 'Advance',
  };

  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');
  const [balance, setBalance] = useState();
  const [address, setAddress] = useState('');
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const [balanceType, setBalanceType] = useState(TYPE.CREDIT);

  const createNewVendor = async () => {
    const amt = Number(balance) || 0;
    const adjustedBalance = balanceType === TYPE.CREDIT ? -Math.abs(amt) : Math.abs(amt);
    const data = {
      name,
      mobile,
      code,
      balance: adjustedBalance,
      address,
    };
    setLoadingIndicator(true);
    try {
      await VendorServices.createVendor(data);
      postAlertMessage({
        text: tPopup('Vendor created successfully'),
        type: 'success',
      });
    } catch (err) {
      postAlertMessage({
        text: err.message,
        type: 'failed',
      });
    }
    setLoadingIndicator(false);
    onSuccess();
  };

  return (
    <div className={styles.popUp} style={{ zIndex: 99999999 }}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Create New Vendor')}</h2>
          <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="top" spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon('Vendor Name')}
                variant="outlined"
                size="small"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberField
                label={tCommon('Vendor Mobile')}
                className={styles.numberInput}
                name="mobile"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon('Vendor Code')}
                variant="outlined"
                size="small"
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <TextField
                    select
                    label={tCommon('Balance Type')}
                    variant="outlined"
                    size="small"
                    value={balanceType}
                    onChange={(e) => setBalanceType(e.target.value)}
                    className={styles.selectBox}
                    fullWidth
                  >
                    <MenuItem value={TYPE.CREDIT}>{tCommon('Credit')}</MenuItem>
                    <MenuItem value={TYPE.ADVANCE}>{tCommon('Advance')}</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={8} >
                  <NumberField
                    label={tCommon('Vendor Balance')}
                    className={styles.numberInput}
                    value={balance}
                    onChange={(e) => setBalance(Number(e.target.value))}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon('Vendor Address')}
                variant="outlined"
                size="small"
                name="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
                multiline
                maxRows={4}
              />
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small" onClick={onClose}>
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={name === '' || mobile === '' || code === '' || loadingIndicator}
              onClick={createNewVendor}
            >
              {tCommon('Create Vendor')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
